import {create} from 'zustand';
import {FC} from 'react';
import {formatDate} from 'date-fns/format'
import {ITEMS_PER_PAGE_DASHBOARD_TRANS} from '../constants/Constants'
import TransmissionsAPI from '../services/TransmissionsAPI';

export const ORDER_TYPE_PENDING = 'enattente';
export const ORDER_TYPE_PENDING_SEARCH = 'enattente_search';

export const ORDER_TYPE_TODAY = 'today';

export const ORDER_SEARCH = 'search';

interface StoreTransmissionsInterface {
    transmissions: Array<object>;
    transmissionCount: number;
    transmissionsDashboard: Array<object>;
    isLoading: boolean;
    type: string;
    searchText: null | string;
    dateStart: null | string;
    dateEnd: null | string;
    isError: false | object;
    sortType: null | string;
    sortOrder: string;
    currentPage: number;
    itemsPerPage: number;
    setType: FC;
    setSearchText: FC;
    setDateStart: FC;
    setDateEnd: FC;
    fetchTransmissions: FC;
    fetchTransmissionsDashboard: FC;
    setSortType: FC;
    setSortOrder: FC;
    resetType: FC;
}
export const useStoreTransmissions = create<StoreTransmissionsInterface>((set, get) => ({
    transmissions: [],
    transmissionsCount: 0,
    transmissionsDashboard: [],
    isLoading: false,
    type: ORDER_TYPE_TODAY,
    searchText: null,
    dateStart: null,
    dateEnd: null,
    isError: false,
    sortType: 'datliv',
    sortOrder: 'desc',
    currentPage: 1,
    itemsPerPage: ITEMS_PER_PAGE_DASHBOARD_TRANS,
    setType: (newType: string): void => {
        if (newType !== get().type) {
            set({type: newType});

            if (newType !== ORDER_SEARCH) {
                get().setSearchText('')
                get().setDateStart('')
                get().setDateEnd('')
            }
        }
    },
    setSearchText: (newSearchText: string): void => {
        set({searchText: newSearchText});
    },
    setDateStart: (newDateStart: string): void => {
        set({dateStart: newDateStart === '' ? null :formatDate(newDateStart, 'yyyy-MM-dd')})
    },
    setDateEnd: (newDateEnd: string): void => {
        set({dateEnd: newDateEnd === '' ? null : formatDate(newDateEnd, 'yyyy-MM-dd')})
    },
    fetchTransmissionsDashboard: () => {
        set({
            type: 'dashboard',
            sortType: 'numcde'
        });
        get().fetchTransmissions(true)
    },
    fetchTransmissions: async (forceReload: boolean = false) => {
        set({isError: false});

        if (forceReload || get().transmissions.length === 0) {
            set({isLoading: true});

            await TransmissionsAPI.getTransmissions(
                get().type,
                get().sortType,
                get().sortOrder,
                get().currentPage,
                get().searchText,
                get().dateStart,
                get().dateEnd,
                get().itemsPerPage,
            ).then(({data}): void => {
                if (data['hydra:member']) {
                    data = data['hydra:member']
                }

                if (data.length === 0) {
                    set({
                        isError: {
                            variant: 'warning',
                            icon: true,
                            content: "Il n'y a actuellement aucune transmission",
                        },
                    });
                }

                set({
                    transmissions: data,
                    transmissionCount: data.length,
                    isLoading: false
                });
            })
        }
    },
    setSortType: (newSortType) => {
        set({sortType: newSortType})
    },
    setSortOrder: (newSortOrder: string) => {
        set({sortOrder: newSortOrder})
    },
    resetType: (): void => {
        get().setType('today');
    }
}));
